import { pipe, flow, Option } from "fp";

import * as Data from "~/Data";
import * as Driver from "~/Driver";

export type Count = {
  readonly drive: number;
  readonly yardMove: number;
  readonly personalUse: number;
  readonly on: number;
  readonly off: number;
  readonly sleeperBerth: number;
};

export const empty = (): Count => ({
  drive: 0,
  yardMove: 0,
  personalUse: 0,
  on: 0,
  off: 0,
  sleeperBerth: 0,
});

export const total = ({
  drive,
  yardMove,
  personalUse,
  on,
  off,
  sleeperBerth,
}: Count): number => drive + yardMove + personalUse + on + off + sleeperBerth;

export const updateFromStatus = (
  previous: Count
): ((status: Driver.Status.Status) => Count) =>
  flow(
    Driver.Status.when<Partial<Count>>({
      drive: () => ({ drive: previous.drive + 1 }),
      yardMove: () => ({ yardMove: previous.yardMove + 1 }),
      personalUse: () => ({ personalUse: previous.personalUse + 1 }),
      on: () => ({ on: previous.on + 1 }),
      off: () => ({ off: previous.off + 1 }),
      sleeperBerth: () => ({ sleeperBerth: previous.sleeperBerth + 1 }),
    }),
    (updated) => ({ ...previous, ...updated })
  );

export const use = (filtered?: boolean): Count =>
  pipe(
    filtered ? Driver.useFilteredStore() : Driver.useStore(),
    Data.Store.toLatest,
    Data.Cache.reduce(empty(), (_id, count, { status }) =>
      pipe(
        Option.fromNullable(status),
        Option.map(updateFromStatus(count)),
        Option.getOrElse(() => count)
      )
    )
  );
